import Reveal from "@/components/Reveal";
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from "@/components/ui/accordion";

const FAQS = [
  {
    q: "¿Por qué no ponéis el precio en la web?",
    a: "Porque no hay un precio único que valga para todos. Un compra-venta de 5 coches al mes en Madrid y un importador de 15 coches en Barcelona no necesitan lo mismo. En la llamada de diagnóstico revisamos tu caso y te damos un precio concreto, sin letra pequeña.",
  },
  {
    q: "¿Qué pasa si no funciona?",
    a: "Sin letra pequeña ni objetivos imposibles. Si en 90 días no ves crecimiento real en visibilidad, conversaciones o ventas, seguimos trabajando contigo sin coste adicional hasta que lo veas.",
  },
  {
    q: "¿Cuánto se tarda en ver resultados?",
    a: "No prometemos ventas el primer día. Lo primero que se mueve es la percepción: en las primeras semanas tu negocio empieza a verse diferente en tu zona. Las conversaciones comerciales cualificadas llegan después, cuando el sistema está afinado a tu stock y tu cliente ideal.",
  },
  {
    q: "¿Cómo filtráis a los curiosos de los que tienen intención real?",
    a: "No te pasamos cualquier contacto. Cada persona que entra pasa por un filtro antes de llegarte: solo hablas con quien ya tiene intención real de comprar o vender, no con quien está comparando 10 sitios a la vez.",
  },
  {
    q: "¿Tengo que gestionar yo las campañas o el contenido?",
    a: "No. Nos encargamos de la estrategia, el contenido, la captación y el filtrado. Tú solo te ocupas de cerrar la venta cuando el cliente ya confía en ti.",
  },
  {
    q: "¿Para qué tipo de negocio funciona esto?",
    a: "Para compra-ventas, importadores y negocios de detailing que ya están vendiendo y quieren un flujo más constante de clientes con intención real. No es para quien vende 1-2 coches al año como afición.",
  },
];

export default function FAQ() {
  return (
    <section id="faq" data-testid="faq-section" className="relative py-24 lg:py-32 border-t border-white/5">
      <div className="absolute inset-0 bg-radial-blue opacity-40 pointer-events-none" />
      <div className="max-w-3xl mx-auto px-4 md:px-8 relative">
        <Reveal>
          <div className="mb-10 lg:mb-14">
            <div className="font-stencil text-xs text-[#00A0A0] tracking-widest mb-4">ANTES DE QUE PREGUNTES</div>
            <h2 className="font-heading text-white text-4xl sm:text-5xl lg:text-6xl uppercase tracking-tight leading-[0.95]">
              Lo que nos preguntan
              <br />
              <span className="font-stencil text-[#00A0A0]">siempre.</span>
            </h2>
          </div>
        </Reveal>

        <Reveal delay={80}>
          <Accordion type="single" collapsible className="w-full" defaultValue="faq-0">
            {FAQS.map((f, i) => (
              <AccordionItem key={i} value={`faq-${i}`} data-testid={`faq-item-${i}`} className="border-white/10">
                <AccordionTrigger className="font-stencil text-white text-base sm:text-lg uppercase tracking-wide py-5 hover:no-underline [&>svg]:text-[#00A0A0]">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-white/60 font-body text-sm sm:text-base leading-relaxed pb-6 pr-6">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
}
